(() => {
  const initializeInquiry = (section) => {
    if (section.dataset.tradeInquiryReady === 'true') return;

    const preferredContact = section.querySelector('[data-trade-preferred-contact]');
    const directContact = section.querySelector('[data-trade-direct-contact]');
    const directContactLabel = section.querySelector('[data-trade-direct-contact-label]');
    const directContactInput = section.querySelector('[data-trade-direct-contact-input]');
    const inquiryType = section.querySelector('[data-trade-inquiry-type]');
    const inquiryGuidance = section.querySelector('[data-trade-inquiry-guidance]');

    if (!preferredContact || !directContact || !directContactLabel || !directContactInput || !inquiryType || !inquiryGuidance) return;

    section.dataset.tradeInquiryReady = 'true';

    const updateDirectContact = () => {
      const channel = preferredContact.value;
      const usesPrivateChat = channel === 'WeChat' || channel === 'WhatsApp';

      directContact.hidden = !usesPrivateChat;
      directContactInput.disabled = !usesPrivateChat;
      directContactInput.autocomplete = channel === 'WhatsApp' ? 'tel' : 'off';
      directContactLabel.textContent = channel === 'WhatsApp' ? 'WhatsApp number (optional)' : 'WeChat ID (optional)';
    };

    preferredContact.addEventListener('change', updateDirectContact);
    updateDirectContact();

    const defaultGuidance = 'Choose a support path to see which details are most useful.';
    const guidanceByType = {
      'Wholesale program': 'Helpful details: target market, product categories, expected order pattern, and preferred contact.',
      'Samples and materials': 'Helpful details: product category, fabric or opacity direction, sample destination, and target date.',
      'Project specification': 'Helpful details: application, approximate quantity, window sizes, and project timeline.',
      'OEM / ODM development': 'Helpful details: product concept, branding or packaging needs, target market, and expected scale.',
      'General trade inquiry': 'Helpful details: what you are sourcing, where it will be sold or installed, and your next decision.'
    };

    const updateInquiryGuidance = () => {
      inquiryGuidance.textContent = guidanceByType[inquiryType.value] || defaultGuidance;
    };

    inquiryType.addEventListener('change', updateInquiryGuidance);
    updateInquiryGuidance();

    document.querySelectorAll('[data-trade-request-type]').forEach((trigger) => {
      if (trigger.dataset.tradeRequestReady === 'true') return;
      trigger.dataset.tradeRequestReady = 'true';
      trigger.addEventListener('click', () => {
        const requestType = trigger.dataset.tradeRequestType;
        const optionExists = [...inquiryType.options].some((option) => option.value === requestType);
        if (!optionExists) return;
        inquiryType.value = requestType;
        inquiryType.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  };

  const initialize = (root = document) => {
    if (root.matches?.('[data-trade-inquiry]')) initializeInquiry(root);
    root.querySelectorAll?.('[data-trade-inquiry]').forEach(initializeInquiry);
  };

  initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
